import { fetch } from '@atlassian/eoc-fetch';

import {
	type ChangeOrderRoutingRuleParams,
	type CreateRoutingRuleParams,
	type Entity,
	type RoutingRules,
	type RoutingRulesResponse,
	type UpdateRoutingRuleParams,
} from '../../../common/types';

export const createRoutingRuleEndpoint = (teamId: string, routingRule: CreateRoutingRuleParams) => {
	return fetch<RoutingRulesResponse>(`/v1/teams/${teamId}/routing-rules`, {
		method: 'POST',
		body: routingRule,
	});
};

export const updateRoutingRuleEndpoint = (teamId: string, routingRule: UpdateRoutingRuleParams) => {
	return fetch<RoutingRulesResponse>(`/v1/teams/${teamId}/routing-rules/${routingRule.id}`, {
		method: 'PUT',
		body: routingRule,
	});
};

export const deleteRoutingRuleEndpoint = (teamId: string, deletedRoutingRuleId: Entity['id']) => {
	return fetch(`/v1/teams/${teamId}/routing-rules/${deletedRoutingRuleId}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};

export const changeOrderRoutingRuleEndpoint = (
	teamId: string,
	payload: ChangeOrderRoutingRuleParams,
) => {
	return fetch(`/v1/teams/${teamId}/routing-rules/${payload.id}/orders`, {
		method: 'POST',
		body: payload,
		responseType: 'headers',
	});
};

export const saveViewEndpoint = (
	teamId: string,
	view: { collapsed: RoutingRules['collapsed'] },
) => {
	return fetch(`/v1/users/ui-preferences/teams/${teamId}/routing-rules`, {
		method: 'PATCH',
		body: view,
		responseType: 'headers',
	});
};

export const completeTaskEndpoint = (teamId: string) => {
	return fetch('/v1/onboarding/complete-task', {
		method: 'POST',
		body: {
			platformTeamId: teamId,
			completedItemKey: 'opsgenie-review-oncall-setup',
		},
	});
};
